
import GermanIcon from '../basics/icons/german-icon.vue'
import EuropeanUnionIcon from '../basics/icons/european-union-icon.vue'

export default {
  name: 'LocaleSwitcherComponent',
  components: {
    GermanIcon,
    EuropeanUnionIcon,
  },
  data() {
    return {
      menuToggle: false,
      currentIcon: GermanIcon,
      languages: {
        en: { icon: EuropeanUnionIcon },
        de: { icon: GermanIcon },
      },
    }
  },
  computed: {
    availableLocales() {
      return this.$i18n.locales
    },
  },
  watch: {
    '$i18n.locale'(newVal) {
      this.currentIcon = this.getIconByCode(newVal)
    },
  },
  mounted() {
    this.currentIcon = this.getIconByCode(this.$i18n.locale)
  },
  methods: {
    closeMenu() {
      this.menuToggle = false
    },
    getIconByCode(code) {
      if (!code) return GermanIcon
      const normalizedCode = code.toLowerCase().includes('de') ? 'de' : 'en'
      return this.languages[normalizedCode]?.icon || GermanIcon
    },
  },
}
